import { generateHash, generateNumericHash } from 'utils/generateHash';

/** Синглтон для генерирования уникальных айдишек для полей, создаваемых на фронте */
class FormFieldModelIdGenerator {
  private constructor() {
    this._hash = generateHash(Date.now());
    this._numericHash = generateNumericHash(this._hash);
  }

  private static _instance: FormFieldModelIdGenerator;

  /** Уникальный хэш, с которого будут начинаться все айдишки */
  private readonly _hash: string;

  private readonly _numericHash: number;

  static get instance(): FormFieldModelIdGenerator {
    if (!FormFieldModelIdGenerator._instance) {
      FormFieldModelIdGenerator._instance = new FormFieldModelIdGenerator();
    }

    return FormFieldModelIdGenerator._instance;
  }

  generateId(): string {
    return `${this._hash}-${generateHash()}`;
  }

  generateCatalogFieldId(): number {
    return this._numericHash;
  }

  isGeneratedId(id: string): boolean {
    return id.startsWith(this._hash);
  }
}

export default FormFieldModelIdGenerator.instance;
